/**
 * Does this `attributes` map match the current argument values?
 *
 * One rule, shared by everything in the editor that has to agree with the
 * player: the timeline's scene blocks and audio refs, the graph, and the
 * chapter selector (DEV-833 — the player gates whole chapters the same way it
 * gates scenes, via `getAvailableChapter()`).
 *
 * **Strict, and deliberately so.** The player compares `attributes[group] !==
 * argValue` with no coercion. This used to be `String(a) === String(b)` in
 * several places, which papered over type drift — an entity stayed visible in
 * the editor while vanishing in the player, which is why DEV-749 read as flaky
 * rather than deterministic. The backend now heals attribute values to their
 * declared type on read, so the editor never sees that drift; leniency would
 * only hide the next regression.
 *
 * An attribute whose argument has no value at all does NOT match — again the
 * player's behaviour (`if (void 0 === r) continue`).
 */
export function attributesMatch(
	attributes: Record<string, unknown> | undefined | null,
	argsMap: Record<string, string | number | boolean>,
): boolean {
	if (!attributes) return true;
	return Object.entries(attributes).every(([key, value]) => {
		if (!(key in argsMap)) return false;
		return value === argsMap[key];
	});
}
